<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          [class.pi]="true"
          [class.pi-file-arrow-up]="true"
          style="font-size: 2rem"></i>
        DESPLEGAR SISTEMA DE IA
      </span>
      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="cancel()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 4 de 6</span>
      <h1 class="font-bold text-[30px] pb-8">Desplegar sistema de IA</h1>

      <h2 class="font-bold text-[24px] pb-6">Cumplimiento ISO 42001</h2>

      <h3 class="font-bold text-[18px] pb-6">Sistema de gestión de IA</h3>

      <div class="grid grid-cols-2">
        <div class="flex flex-col">
          <desy-select
            formControlName="iso42001"
            classes="min-w-full">
            <desy-label>Validación contra controles ISO 42001*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay validación
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'iso42001', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!iso42001ExtraFilled() && iso42001Required()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="iso42001Required()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Con CSV</span>
            <desy-input
              id="iso42001Csv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="iso42001Csv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="text-[14px] text-neutral-dark block">Descripción</span>
          <desy-textarea
            id="iso42001Description"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="iso42001Description"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <h2 class="font-bold text-[24px] pb-6">Cumplimiento Orden HAP/796/2025</h2>

      <h3 class="font-bold text-[18px] pb-6">Principios básicos</h3>

      <div class="grid grid-cols-2">
        <div class="flex flex-col">
          <desy-select
            formControlName="dataSovereignty"
            classes="min-w-full">
            <desy-label>Soberanía del dato protegida*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay soberanía
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'dataSovereignty', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="dataSovereigntyRequired()">
        <div class="flex flex-col -mt-4 mb-4">
          <desy-label>Descripción*</desy-label>
          <desy-textarea
            id="dataSovereigntyDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la soberanía del dato protegida'"
            formControlName="dataSovereigntyDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'dataSovereigntyDescription', formSubmitted()) as error;
              else dataSovereigntyDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #dataSovereigntyDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>

      <div class="grid grid-cols-2">
        <div class="flex flex-col">
          <desy-select
            formControlName="equityAndAccess"
            classes="min-w-full">
            <desy-label>Equidad y acceso universal verificado*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay equidad
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'equityAndAccess', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="equityAndAccessRequired()">
        <div class="flex flex-col -mt-4">
          <desy-label>Descripción*</desy-label>
          <desy-textarea
            id="equityAndAccessDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la equidad y acceso universal verificado'"
            formControlName="equityAndAccessDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="
              getError(form, 'equityAndAccessDescription', formSubmitted()) as error;
              else equityAndAccessDescriptionInfo
            ">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #equityAndAccessDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</form>
